import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React from 'react';
import Box from '../Box';
import Text from '../Text';

function SortableEmpty(_ref) {
  var emptyText = _ref.emptyText,
      isDraggingOver = _ref.isDraggingOver,
      restProps = _objectWithoutPropertiesLoose(_ref, ["emptyText", "isDraggingOver"]);

  return /*#__PURE__*/React.createElement(Box, _extends({
    column: 1,
    row: 1,
    padding: 1,
    backgroundColor: isDraggingOver ? 'warning-lightest' : 'white'
  }, restProps), /*#__PURE__*/React.createElement(Box, {
    padding: 0.5,
    backgroundColor: isDraggingOver ? 'warning-lightest' : 'white',
    borderWidth: 1,
    borderStyle: "dashed",
    borderColor: isDraggingOver ? 'warning' : 'grey-5',
    radius: 3
  }, /*#__PURE__*/React.createElement(Text, {
    fontSize: 5,
    textAlign: "center",
    opacity: isDraggingOver ? 0 : 1
  }, emptyText)));
}

export default SortableEmpty;